import { useEffect, useState } from 'react';
import { useWindowSize } from 'react-use';

const useGetCSSVariables = (variablesToGet = []) => {
  const [cssVariableValues, setCssVariableValues] = useState({});
  const { width: screenWidth } = useWindowSize();
  const variablesToGetString = JSON.stringify(variablesToGet);

  useEffect(() => {
    const newValues = variablesToGet.reduce(
      (acc, variableToGet) => ({
        ...acc,
        [variableToGet]: getComputedStyle(
          document.documentElement
        ).getPropertyValue(variableToGet),
      }),
      {}
    );

    // Only update if values actually changed
    setCssVariableValues(prevValues => {
      const hasChanged = Object.keys(newValues).some(
        key => newValues[key] !== prevValues[key]
      );
      return hasChanged ? newValues : prevValues;
    });
  }, [screenWidth, variablesToGet, variablesToGetString]);

  return cssVariableValues;
};

export default useGetCSSVariables;
